import { createTheme, ThemeProvider } from "@mui/material/styles";

import styled from "styled-components";
import MUIRichTextEditor from "mui-rte";
import React, { useState } from "react";
import { EditorState, convertToRaw } from "draft-js";

const TextEditor = ({
  handleChangeText,
  type,
  value,
  maxLength,
  name,
  editorRef,
}) => {
  const [text, setText] = useState(value ? JSON.stringify(value) : "");

  const change = (event) => {
    const plainText = event.getCurrentContent().getPlainText(); // for plain text

    const rteContent = convertToRaw(event.getCurrentContent()); // for rte content with text formating
    handleChangeText && handleChangeText(rteContent, type);
  };
  const myTheme = createTheme({
    overrides: {
      MUIRichTextEditor: {
        root: {
          marginTop: type ? 20 : 0,
          width: "100%",
          marginBottom: type ? 20 : 0,
          border: type ? "1px solid lightGrey" : "",
          display: type ? "" : "none"
        },
        editor: {
          borderTop: type ? "1px solid lightGrey" : "",
          padding: type ? 10 : 0,
          height: type ? 100 : 0,
        //  maxHeight: type ? 100 : 0,
          overflow: "auto",
        },
      },
    },
  });
  return (
    <div>
      <ThemeProvider theme={myTheme}>
        <MUIRichTextEditor
          label={type ? "Type Text..." : ""}
          id={type}
          controls={
            type === "question" && name !== "content"
              ? ["bold", "italic", "underline", "strikethrough", "undo", "redo"]
              : !type
              ? [""]
              : [
                  "bold",
                  "italic",
                  "underline",
                  "link",
                  "strikethrough",
                  "undo",
                  "redo",
                ]
          }
          //inlineToolbar={true}
          onChange={change}
          value={text}
          maxLength={maxLength ? maxLength : 400}
          ref={editorRef}
        />
      </ThemeProvider>
    </div>
  );
};

export default TextEditor;
